import * as tslib_1 from "tslib";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { QUESTION_TYPE_MAP } from "../constant";
let QuestionPreview = class QuestionPreview extends Vue {
    get questionType() {
        const type = QUESTION_TYPE_MAP.find((type) => {
            return type.id === this.type;
        });
        return type && type.text || "";
    }
    get isAnswerArray() {
        return Array.isArray(this.answer);
    }
    get isAnalysisArray() {
        return Array.isArray(this.analysis);
    }
    onClose() { }
};
tslib_1.__decorate([
    PropSync('visible', { type: Boolean, default: false })
], QuestionPreview.prototype, "inner_visible", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], QuestionPreview.prototype, "type", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], QuestionPreview.prototype, "topic", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], QuestionPreview.prototype, "options", void 0);
tslib_1.__decorate([
    Prop({ type: [String, Array], default: '' })
], QuestionPreview.prototype, "answer", void 0);
tslib_1.__decorate([
    Prop({ type: [String, Array], default: '' })
], QuestionPreview.prototype, "analysis", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], QuestionPreview.prototype, "children", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], QuestionPreview.prototype, "loading", void 0);
QuestionPreview = tslib_1.__decorate([
    Component({
        name: 'QuestionPreview',
    })
], QuestionPreview);
export default QuestionPreview;
